// Download a file the API generates on the fly (an Excel export, a report)
// with the auth token attached.
//
// apiGet cannot be used for these: it parses the body as JSON or text, which
// corrupts a binary workbook. This keeps the response as a blob and lets the
// server name the file through Content-Disposition, the same way the invoice
// PDF download does.

import { filenameFromHeader } from './downloadInvoicePdf';

export async function downloadApiFile(endpoint, fallbackName) {
  const response = await fetch(`${process.env.REACT_APP_API_URL || ''}${endpoint}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

  if (!response.ok) {
    let detail = 'Download failed';
    try {
      const data = await response.json();
      detail = data.detail || detail;
    } catch (e) {
      /* non-JSON error body */
    }
    throw new Error(detail);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filenameFromHeader(response.headers.get('Content-Disposition')) || fallbackName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
